module.exports = __webpack_public_path__ + "static/media/TechCover.943874c5.png";